import {
  DataSharingOutlinedIcon,
  ShareMyDataOutlinedIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type {
  FunctionComponent,
  SVGProps,
} from "react"

import styles from "./DataSharingIndex.module.scss"
import {
  PageLink,
  PageTemplate,
} from "src/components"
import { usePolyglot } from "src/contexts"

const pages = [
  {
    routePath: "/data_sharing/sharing" as const,
    id: "sharing",
    polyglotPhraseKey: "pages.data_sharing.pages.sharing",
    Icon: ShareMyDataOutlinedIcon as FunctionComponent<SVGProps<SVGElement>>,
  },
  {
    routePath: "/data_sharing/following" as const,
    id: "following",
    polyglotPhraseKey: "pages.data_sharing.pages.following",
    Icon: DataSharingOutlinedIcon as FunctionComponent<SVGProps<SVGElement>>,
  },
]

const polyglotPrefix = "pages.data_sharing."

export function DataSharingIndex() {
  const polyglot = usePolyglot()

  return (
    <PageTemplate
      user="account"
      title={polyglot.t("components.page_header.pages.data_sharing")}
    >
      <div className={styles.container}>
        <div className={styles.heading}>
          <div className={styles.description}>
            {polyglot.t(`${polyglotPrefix}description`)}
          </div>
          <a
            className={styles.moreInfo}
            href="https://help.sugarmate.io/en/articles/11488605-managing-data-sharing"
          >
            {polyglot.t(`${polyglotPrefix}more_info`)}
          </a>
        </div>

        {pages.map((pageLinkProps) => (
          <PageLink
            key={pageLinkProps.routePath}
            {...pageLinkProps}
          />
        ))}
      </div>
    </PageTemplate>
  )
}
